import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import Container from "../../components/Container";
import styles from "./index.module.scss";
import exclamationIconUrl from "/assets/img/common/exclamation-icon.svg";
export default function IndexPage() { 
    return (
        <>
            <Helmet>
                <title>
                    西部ガスグループ公式オンラインショップ
                </title>
                <meta
                    name="description"
                    content="西部ガスグループ公式オンラインショップでは、お客さまの暮らしを便利で快適にする ガス機器をお得な価格で提案してまいります。 パロマ、リンナイ、ノーリツといった信頼のメーカーのガス機器を各種取り揃えております。"
                />
                <meta
                    property="og:title"
                    content="西部ガスグループ公式オンラインショップ"
                />
                <meta
                    property="og:description"
                    content="西部ガスグループ公式オンラインショップでは、お客さまの暮らしを便利で快適にする ガス機器をお得な価格で提案してまいります。 パロマ、リンナイ、ノーリツといった信頼のメーカーのガス機器を各種取り揃えております。"
                />
                <meta
                    property="og:url"
                    content="https://onlineshop.saibugas.co.jp/"
                />
                <meta
                    property="og:site_name"
                    content="西部ガスグループ公式オンラインショップ"
                />
                <meta property="og:image" content="/assets/img/common/index-ogp.png" />
                <meta name="robots" content="index,follow" />
            </Helmet>
            <div className={styles.indexPage}>
                <Container style={{ padding:'8rem 0 11rem' }}>
                    <h2 className={`noto-sans-jp-black ${styles.indexPage__title}`}>西部ガスグループ<br/>公式オンラインショップ</h2>
                    <p className={`${styles.indexPage__description} noto-sans-jp-medium`}>西部ガスグループでは、ガス機器を通じて<br/>あなたの快適な暮らしづくりを応援しています。</p>
                    <div className={styles.indexPage__exclamation}>
                        <img src={exclamationIconUrl} alt="exclamation-icon" />
                        <p className={`${styles.indexPage__exclamationText} noto-sans-jp-black`}>都市ガス用ガス機器の取り扱いのみとなっております</p>
                    </div>
                    <p className={`${styles.indexPage__linkText} noto-sans-jp-bold`}>
                        テーブルコンロを購入ご希望の方はこちら
                    </p>
                    <Link to="/pr_tableconro" target="_blank">
                        <img src="/assets/img/common/bnr_tc.png" alt="ガスファンヒーター" />
                    </Link>
                    <p className={`${styles.indexPage__linkText} noto-sans-jp-bold`} style={{ marginTop: '3.7rem' }}>
                        ガスファンヒーターを購入ご希望の方はこちら
                    </p>
                    <Link to="/pr_fh" target="_blank">
                        <img src="/assets/img/common/bnr_fh.png" alt="ガスファンヒーター" />
                    </Link>
                </Container>
            </div>
        </>
    );
}
